import { render } from "./WeekPicker.vue?vue&type=template&id=9da7fe84&scoped=true"
import script from "./WeekPicker.vue?vue&type=script&lang=js"
export * from "./WeekPicker.vue?vue&type=script&lang=js"

import "./WeekPicker.vue?vue&type=style&index=0&id=9da7fe84&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da7fe84"]])

export default __exports__